import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';

import { Icon } from 'Icons';

import './styles.css';

/*
This table will accept the following custom hooks:
- useStandardTable
- useSortTable
Props From DT:
- noDataMessage: Needs to be customzied per table & translated
*/
const Table = ({
  className,
  columnsLength,
  getTableProps,
  getTableBodyProps,
  headerGroups,
  noDataMessage,
  prepareRow,
  rows,
}) => {
  return (
    <table
      {...getTableProps()}
      className={`w-full border-collapse text-md table-button-styles ${className}`}
    >
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              const headerProps = column.canSort
                ? column.getHeaderProps(column.getSortByToggleProps())
                : column.getHeaderProps();
              return (
                <th
                  {...headerProps}
                  className="uppercase text-left text-gray-5 border-b-2 border-gray-2 py-4 px-2"
                >
                  <span className={column.canSort ? 'relative' : undefined}>
                    {column.render('Header')}
                    {column.isSorted && (
                      <span className="absolute -right-4 top-1/2 transform -translate-y-1/2">
                        {column.isSortedDesc ? (
                          <Icon icon={faCaretDown} />
                        ) : (
                          <Icon icon={faCaretUp} />
                        )}
                      </span>
                    )}
                  </span>
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.length ? (
          rows.map((row) => {
            // prepareRow lazily initializes a row before knowing if it's rendered
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className="border-b border-gray-1 hover:bg-gray-1"
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()} className="py-4 px-2">
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })
        ) : (
          <tr className="text-center border-b border-gray-1">
            <td className="py-4 px-2" colSpan={columnsLength}>
              {noDataMessage}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

Table.defaultProps = {
  className: '',
};

Table.propTypes = {
  className: PropTypes.string,
  columnsLength: PropTypes.number.isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  getTableProps: PropTypes.func.isRequired,
  headerGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
  noDataMessage: PropTypes.string.isRequired,
  prepareRow: PropTypes.func.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Table;
